import React from "react";

export default (props) => {
  return (
    <div style={{ position: "relative", height: "20px", left: "80px" }}>
      <div className="dotLoader">
        <span className="loader__dot">.</span>
        <span className="loader__dot">.</span>
        <span className="loader__dot">.</span>
      </div>
    </div>
  );
};
